import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { SETTINGS } from "@/constants/testIds";

export function SyncSettings({ settings, sync, setSync, onSave }) {
  return (
    <Card className="p-6 border-slate-200 shadow-sm">
      <h3 className="text-base font-semibold text-slate-900 mb-4">Sincronización automática</h3>
      <div className="space-y-4">
        <div className="flex items-center justify-between p-3 rounded-md border border-slate-200">
          <div>
            <div className="text-sm font-medium text-slate-900">Sincronización programada</div>
            <div className="text-xs text-slate-500">
              Ejecuta la sincronización delta automáticamente cada N minutos.
            </div>
          </div>
          <Switch checked={sync.auto_sync_enabled}
            onCheckedChange={(v) => setSync({ ...sync, auto_sync_enabled: v })} />
        </div>
        <div className="space-y-1.5 max-w-xs">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">
            Intervalo (minutos)
          </Label>
          <Input type="number" min="5" value={sync.interval_minutes}
            onChange={(e) => setSync({ ...sync, interval_minutes: parseInt(e.target.value || "60", 10) })}
            className="focus-visible:ring-orange-500" />
        </div>
        <div className="text-xs text-slate-500">
          Última sincronización: <strong>{settings?.sync?.last_sync_at ? new Date(settings.sync.last_sync_at).toLocaleString("es") : "Nunca"}</strong>
          {settings?.sync?.last_sync_status && (
            <> · Estado: <strong>{settings.sync.last_sync_status}</strong></>
          )}
        </div>
      </div>
      <div className="mt-6 flex justify-end">
        <Button onClick={onSave} className="bg-orange-600 hover:bg-orange-700 text-white"
          data-testid={SETTINGS.saveSyncBtn}>
          Guardar sincronización
        </Button>
      </div>
    </Card>
  );
}
